<template>
  <td class="table-avatar-cell">
    <div class="avatar-wrapper">
      <avatar :id="source" :initials="initials" />
    </div>
  </td>
</template>
<script>
import TableCellMixin from "./TableCellMixin.js";

export default {
  mixins: [TableCellMixin],
  computed: {
    initials() {
      return (
        String(
          `${this.row?.firstName || ""} ${this.row?.lastName || ""}`,
        ).trim() || this.row.title
      );
    },
    source() {
      return this.$sdk.utils.id(this.value) || this.$sdk.utils.id(this.row);
    },
  },
};
</script>

<style scoped lang="scss">
td {
  // min-width:60px;
  // width:60px;
  padding: 0.3em !important;

  .avatar-wrapper {
    width: 2.6em;
  }
}
</style>
